<div class="setting-page my-3">
  <div class="settings-content mr-4">
    <conpulse-web-chat-room-list (conversationClickEvent)="updateconversation($event)" [chatRoomId]="chatRoomId"> </conpulse-web-chat-room-list>
  </div>
  <div class="flex-one settings-content-section settings-content">
    <conpulse-web-chat-messages (updateConversationList)="updateconversationList($event)" [conversation]="conversation"> </conpulse-web-chat-messages>
  </div>
</div>
